import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { whatsappLink } from '../utils/contact';

const CTASection = ({
    title,
    description,
    buttonText,
    buttonLink,
    buttonTo,
    icon = null,
    iconType = "icon", // "icon" or "image"
    className = "",
    titleClassName = "",
    bgImage
}) => {
    const { t } = useLanguage();
    const link = buttonLink || whatsappLink(t('contact.whatsapp.generic'));

    return (
        <div className={`mxd-section overflow-hidden ${className}`}>
            <div className="mxd-container">
                <div className="mxd-block">
                    <div className="mxd-promo">
                        <div className="mxd-promo__inner anim-zoom-out-container">
                            <div
                                className="mxd-promo__bg"
                                style={bgImage ? { backgroundImage: `url(${bgImage})` } : undefined}
                            ></div>
                            <div className="mxd-promo__content">
                                <p className="mxd-promo__title anim-uni-in-up">
                                    {icon && (
                                        <span className="mxd-promo__icon">
                                            {iconType === "image" ? (
                                                <img src={icon} alt={t('common.alt_texts.icon')} />
                                            ) : (
                                                <i className={icon}></i>
                                            )}
                                        </span>
                                    )}
                                    <span className={`mxd-promo__caption reveal-type ${titleClassName}`}>{title}</span>
                                </p>
                                {description && (
                                    <p
                                        className="mxd-promo__description mt-3 t-large"
                                        style={{ color: '#ffffff', opacity: 0.92, fontWeight: 500, fontSize: '1.7rem', lineHeight: '1.55' }}
                                    >
                                        {description}
                                    </p>
                                )}
                                <div className="mxd-promo__controls anim-uni-in-up mt-4">
                                    {buttonTo ? (
                                        <Link
                                            className="btn btn-anim btn-primary btn-large slide-right-up btn-long-text"
                                            to={buttonTo}
                                        >
                                            <span className="btn-caption">{buttonText}</span>
                                            <i className="ph-bold ph-arrow-up-right"></i>
                                        </Link>
                                    ) : (
                                        <a
                                            className="btn btn-anim btn-primary btn-large slide-right-up btn-long-text"
                                            href={link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <span className="btn-caption">{buttonText}</span>
                                            <i className="ph-bold ph-arrow-up-right"></i>
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CTASection;
